/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellOffIcon24Solid = forwardRef('NotificationBellOffIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.178.376A1.25 1.25 0 0 0 1.41 2.144l3.83 3.83a7.724 7.724 0 0 0-.978 3.776v4.377a.388.388 0 0 1-.075.23L2.244 17.01C1.639 17.836 2.228 19 3.25 19h15.017l2.643 2.644a1.25 1.25 0 0 0 1.768-1.768L3.178.376Z" }),
        React.createElement("path", { d: "M19.738 9.75v4.375L8.466 2.853A7.696 7.696 0 0 1 12 2c4.274 0 7.738 3.47 7.738 7.75Z" }),
        React.createElement("path", { d: "M12 23a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3Z" })));
});
